
import * as React from "react";
import CountDownComp from "../global/CountDownComp";
import { ISetUrl } from "../../AppMain";
import { IActiveOrders } from "../../interfaces/IOrder";
import DateTool from "../../../avernus/datetool/source/DateTool";
import { Api } from "../../lib/Api";
import { Lng } from "../../../languages/Languages";
import Header from "../Header";

interface IOrderStatusLabelProps {
    order: any
}

interface IOrderStatusLabelState {
}

export default class OrderStatusLabel extends React.Component<IOrderStatusLabelProps, IOrderStatusLabelState>{

    constructor(props:IOrderStatusLabelProps){
        super(props);
        this.state = {

        };


    }


    render() {

        const beforeProcessStatuses = ['pending', 'modify_hour', 'waiting_photo_request'];

        return (
            <>
                {
                    beforeProcessStatuses.includes(this.props.order.status.key) &&
                    <div className="waiting-confirmation">
                        {
                            this.props.order.status.key == 'pending' &&
                            <p>waiting for confirmation</p>
                        }
                        {
                            this.props.order.status.key == 'modify_hour' &&
                            <p style = {{fontSize: '16px'}}>{this.props.order.offer.creator.name} proposes different working hours</p>
                        }
                        {
                            this.props.order.status.key == 'waiting_photo_request' &&
                            <>
                                <p style = {{fontSize: '16px', marginBottom: '20px'}}>{this.props.order.offer.creator.name} asks you to send a picture of the job</p>
                                <img src = "/img/upload_photo_icon.png" />
                            </>
                        }

                    </div>
                }

                {
                    this.props.order.status.key == 'processing' &&
                    <div className = "process-order">
                        <p className = "creator-name">{this.props.order.offer.creator.name} arrives</p>
                        <div className = "remaining-time">
                            {
                                Object.keys(this.props.order.formattedStartDateTime).map((timeType, index) => (
                                    <>
                                        <div className = "time">
                                            <p>{this.props.order.formattedStartDateTime[timeType]}</p>
                                            <label>{timeType}</label>
                                        </div>
                                        {
                                            index != Object.keys(this.props.order.formattedStartDateTime).length - 1 &&
                                            <div className = "colon">:</div>
                                        }

                                    </>
                                ))
                            }
                        </div>
                    </div>
                }
            </>

        );
    }
}
